import React from 'react';

import { Form, Message } from 'semantic-ui-react'

import { TagsInputComponent, OwnersInputComponent, TagsViewComponent, OwnersViewComponent } from './control_library_components'
import AutoLinkTextarea from '../../components/autolink_textarea/autolink_textarea';

export default function LibraryControlForm(props) {
  const { control, handleControlChange, controlErrors, translations } = props;
  const { custom_id, title, subtitle, description } = translations;
  return (
    <Form className="library-control-form">
      <Form.Field>
        <label>{custom_id}</label>
        <input name='custom_id' placeholder={custom_id} defaultValue={control.custom_id} onChange={handleControlChange}/>
      </Form.Field>
      {
        controlErrors && controlErrors.custom_id &&
        <Message error header='' list={controlErrors.custom_id} />
      }
      <Form.Field>
        <label>{title}</label>
        <input name='title' placeholder={title} defaultValue={control.title} onChange={handleControlChange}/>
      </Form.Field>
      {
        controlErrors && controlErrors.title &&
        <Message error header='' list={controlErrors.title} />
      }
      <Form.Field>
        <label>{subtitle}</label>
        <input name='subtitle' placeholder={subtitle} defaultValue={control.subtitle} onChange={handleControlChange}/>
      </Form.Field>
      <Form.Field>
        <label>{description}</label>
        <AutoLinkTextarea name='description' placeholder={description} value={control.description} onChange={handleControlChange}/>
      </Form.Field>
      <Form.Field>
        <div>
          <OwnersInputComponent
            control={control}
            defaultOwnerOptions={props.defaultOwnerOptions}
            updateOwners={props.updateOwners}
            createNewOwner={props.createNewOwner}
            saveNow={false}
            translations={translations}
          />
          <OwnersViewComponent
            control={control}
            removeOwner={props.removeOwner}
            saveNow={false}
          />
        </div>
        <div>
          <TagsInputComponent
            control={control}
            defaultTagOptions={props.defaultTagOptions}
            updateTags={props.updateTags}
            createNewTag={props.createNewTag}
            saveNow={false}
          />
          <TagsViewComponent
            control={control}
            removeTag={props.removeTag}
            saveNow={false}
          />
        </div>
      </Form.Field>
    </Form>
  )
}


// WEBPACK FOOTER //
// ./src/views/control_library/library_control_form.js